<template>
    <div class="z-preloader">
        <span class="z-preloader__item z-preloader__item--accent"></span>
        <span class="z-preloader__item z-preloader__item--sm1"></span>
        <span class="z-preloader__item z-preloader__item--sm2"></span>
        <span class="z-preloader__item z-preloader__item--sm3"></span>
    </div>
</template>

<script>
export default {
    name: 'z-preloader',
    computed: {
    }
}
</script>

<style lang="scss">
    .z-preloader {
        display: flex;
        align-items: center;
        margin-right: -8px;

        &__item {
            width: 6px;
            height: 6px;
            display: block;
            background-color: $token-colors-tertiary;
            margin-right: 8px;

            &--accent {
                width: 10px;
                height: 10px;
                animation: preloader 1s linear infinite;

                @keyframes preloader {
                    0% {
                        order: 0;
                    }
                    25% {
                        order: 2;
                    }
                    50% {
                        order: 4;
                    }
                    75% {
                        order: 6;
                    }
                    100% {
                        order: 6;
                    }
                }
            }

            &--sm1 {
                order: 1;
            }

            &--sm2 {
                order: 3;
            }

            &--sm3 {
                order: 5;
            }
        }
    }
</style>
